import React from 'react';
import SourceBadge from './SourceBadge';
import './RAGAnalysis.css';

const RADIUS_CONFIG = {
    single_user: { label: 'Single User', className: 'radius-low' },
    all_users: { label: 'All Users', className: 'radius-high' },
    server: { label: 'Server', className: 'radius-critical' },
    infrastructure: { label: 'Infrastructure', className: 'radius-critical' },
};

const SecurityImpactSection = ({ securityImpact, source, blastRadius, enablesFurtherAttacks }) => {
    if (!securityImpact) return null;

    const radiusCfg = RADIUS_CONFIG[blastRadius] || null;
    const attacks = Array.isArray(enablesFurtherAttacks) ? enablesFurtherAttacks : [];

    return (
        <div className="rag-section security-impact-section">
            <div className="rag-section-header">
                <h4 className="rag-section-title">Security Impact</h4>
                <SourceBadge source={source} />
            </div>

            <p className="rag-section-body">{securityImpact}</p>

            {(radiusCfg || attacks.length > 0) && (
                <div className="impact-chips">
                    {radiusCfg && (
                        <span className={`impact-chip ${radiusCfg.className}`} title="Blast radius of this vulnerability">
                            Blast Radius: {radiusCfg.label}
                        </span>
                    )}
                    {attacks.map((atk, i) => (
                        <span key={i} className="impact-chip attack-chip" title="Secondary attack enabled by this vulnerability">
                            {atk}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SecurityImpactSection;
